import { StorageServiceProvider } from '../providers/storage/storage.service.provider';

export function storageConfig( storageServiceProvider: StorageServiceProvider ) {
  storageServiceProvider.setPrefix('gmc');
}

storageConfig.$inject = [ 'StorageServiceProvider' ];



// WEBPACK FOOTER //
// ./app/core/config/storage.config.ts